import { IDataProducto } from "@/shared/interfaces";
import { IDataSerieParams } from "@/shared/interfaces/erp/administration/productofactorserie.interface";
import { create } from "zustand";

interface UseSeriesReporteStockState {
  isOpenModal: boolean
  setIsOpenModal: (isOpenModal: boolean) => void
  params: IDataSerieParams | null;
  setParams: (params: IDataSerieParams | null) => void
  producto: IDataProducto | null;
  setProducto: (producto: IDataProducto | null) => void;

  cleanSeries: () => void
}

export const useSeriesReporteStock = create<UseSeriesReporteStockState>((set) => ({
  producto: null,
  setProducto: (producto) => {
    set({
      producto
    })
  },
  params: {},
  isOpenModal: false,
  setIsOpenModal(isOpenModal) {
    set({
      isOpenModal,
    })
  },
  setParams(params) {
    set({
      params
    })
  },
  cleanSeries() {
    set({
      producto: null,
      isOpenModal: false,
      params: null
    })
  },

}))